import { Divider, DividerProps } from '@chakra-ui/react';
import type { FC } from 'react';
export type QDividerProps = DividerProps;

export const QDivider: FC<QDividerProps> = (props) => {
  return <Divider {...props} />;
};

QDivider.displayName = 'QDivider';
